import { render } from "./NotificationsPaginationWrapper.vue?vue&type=template&id=4504b96c"
import script from "./NotificationsPaginationWrapper.vue?vue&type=script&lang=js"
export * from "./NotificationsPaginationWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__